// style
// ----------------------------------------------------------
import '../sass/style.scss'

// Base
// ----------------------------------------------------------
import { magazineEnableTouchStartEvent } from './Base/magazineEnableTouchStartEvent';
import { magazineSetDraggableFalseAllImage } from './Base/magazineSetDraggableFalseAllImage';

magazineEnableTouchStartEvent();
magazineSetDraggableFalseAllImage();

// Components
// ----------------------------------------------------------
import { magazineLogoScrollHidden } from './Components/magazineLogoScrollHidden';
import { magazineMvSlide } from './Components/magazineMvSlide';
import { magazineHeaderHamburger } from './Components/magazineHeaderHamburger';
import { magazineCategorySelect } from './Components/magazineCategorySelect';
import { magazineGenerateTableOfContent } from './Components/magazineGenerateTableOfContent';
import { magazineGenerateShareSnsLink } from './Components/magazineGenerateShareSnsLink';
import { magazineObserveFadeCta } from './Components/magazineObserveFadeCta';

magazineLogoScrollHidden();
magazineMvSlide();
magazineHeaderHamburger();
magazineCategorySelect();
magazineGenerateTableOfContent();
magazineGenerateShareSnsLink();
magazineObserveFadeCta();